import { ContractStatus } from '@qover-private/protos-web/qover/dojo/bike/v1/api';
import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/bike/v1/contract';
import { Http, AbstractProductService } from '@qover/services';
import * as DraftFactory from '../domain/factories/DraftFactory';
import * as DraftMapper from '../domain/mappers/draftMapper';
import { Variant } from '../domain/Terms';
import { Draft } from '../domain/Draft';

class ProductService extends AbstractProductService<Draft, DraftProtos> {
  toJson(payload: Draft): DraftProtos {
    return DraftMapper.mapToApiRequest(payload);
  }

  fromJson(response: DraftProtos): Draft {
    return DraftFactory.createFromApiResponse(response);
  }

  getVariants(country: string) {
    if (['BE', 'FR', 'NL', 'DE'].includes(country)) {
      return Promise.resolve([
        Variant.VARIANT_THEFT_ASSISTANCE,
        Variant.VARIANT_THEFT_DAMAGE_ASSISTANCE,
      ]);
    }

    return Promise.resolve([
      Variant.VARIANT_THEFT,
      Variant.VARIANT_THEFT_DAMAGE,
    ]);
  }

  getPartialContract(id: string): Promise<ContractStatus> {
    return Http.get({
      basePath: this.basePath,
      path: `/v1/contracts/${id}/partial`,
    });
  }

  updateSoftAmend(id: string, data: any) {
    return Http.put({
      basePath: this.basePath,
      path: `/v1/contracts/${id}/soft-amend`,
      data,
    });
  }

  createRessourceSignedUrl(id: string, type: string) {
    return Http.post({
      basePath: this.basePath,
      path: `/v1/contracts/${id}/upload-pictures`,
      params: {
        type,
      },
      data: {},
    });
  }

  uploadRessourceToBucket(signedUrl: string, resource: FormData) {
    return Http.getFetch()(signedUrl, {
      method: 'POST',
      body: resource,
    }).then(res => res.text());
  }

  getPicturesUploadStatus(id: string) {
    return Http.get({
      basePath: this.basePath,
      path: `/v1/contracts/${id}/upload-status`,
    });
  }
}

export const productService = new ProductService('bike');
